import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { UTILS } from "utils";
import { API } from "api";
import { CONSTANTS as C } from "config";
import AppSwitch from "components/ui/AppSwitch.jsx";
import AppHeading2 from "components/ui/AppHeading2.jsx";
import AppInput from "components/ui/AppInput.jsx";
import AppSelect from "components/ui/AppSelect.jsx";
import AppSimpleText from "components/ui/AppSimpleText.jsx";
import AppCollapse from "components/ui/AppCollapse.jsx";
import StoreHoursSection from "./HoursSelection"
// import PaymentTypes from "./StorePaymentMethodSection";
// import WorkingHours from "./DineInHoursSection";
// import RadioButton from "../../../components/RadioButton";
// import TextInput from "../../../components/TextInput";
function Delivery({ store, addStore, type, setStore, handleStoreInfo, defaultOpen = false }) {
  const [serviceTypes, setServiceTypes] = useState([]);
  const { t } = useTranslation();
  const infoMessages = [
    {
      message:
        "To Receive Payments in Your Bank Account Please email us at",
      separator: "or",
      links:[
        {
          href: `mailto:support@comera.io`,
          text: "support@comera.io",
          target: "_blank",
        },
        {
          href: `https://wa.me/${(process.env.REACT_APP_SUPPORT_MOBILE || "").replace(/[^0-9]/g, "")}?text=How%20can%20we%20help?`,
          text: "Contact our Support Team",
          target: "_blank",
        },
      ],
    },
    {
      message: "To Enable Payment Methods (Cash, Card Payments, Card on Delivery, etc.) ",
      separator: "and we’ll help you activate the payment options you need",
      links:[
        {
          href: `https://wa.me/${(process.env.REACT_APP_SUPPORT_MOBILE || "").replace(/[^0-9]/g, "")}?text=How%20can%20we%20help?`,
          text: "Contact our Support Team",
          target: "_blank",
        },
      ],
    },
  ];
  const getServiceTypes = async () => {
    const userDetail = UTILS.getCurrentUser();
    const result = await API.GET_SERVICE_TYPES({
      token: userDetail.token,
    });
    if (result && result.success === 1) {
      setServiceTypes(result.data);
    } else {
    }
  };
  useEffect(() => {
    getServiceTypes();
  }, []);
  const toggleDelivery = (isDeliveryEnabled, key) => {
    if (isDeliveryEnabled) {
      setStore((store) => ({
        ...store,
        values: {
          ...store.values,
          [C.ISDINEINENABLED]: !isDeliveryEnabled,
          [C.KEY_SERVICE_TYPES]: store.values[C.KEY_SERVICE_TYPES].filter(
            (item) => item !== key
          ),
        },
      }));
    } else {
      setStore((store) => ({
        ...store,
        values: {
          ...store.values,
          [C.ISDINEINENABLED]: !isDeliveryEnabled,
          serviceType: [...store.values.serviceType, key],
        },
      }));
    }
  };
  const isON = (item) => {
    const arr = store.values[C.KEY_SERVICE_TYPES];
    const found = arr?.find((obj) => obj === item);
    return found ? true : false;
  };
//   const ServiceType = () => {
//     return (
//       <div className="mb-5">
//         <RadioButton
//           label={t("Contactless dining")}
//           value={isON(serviceTypes[2]?._id)}
//           keyVal={C.KEY_SERVICE_TYPES + "_" + serviceTypes[2]?._id}
//           handleValues={() => {
//             toggleDelivery(
//               store.values[C.ISDINEINENABLED],
//               serviceTypes[2]?._id
//             );
//           }}
//         />
//       </div>
//     );
//   };
  const getValue = (key) => {
    if (store && store.values[key]) return store.values[key];
    else return "";
  };

  const handlePaymentTypes = (key, val) => {
    const v = key;
    let paymentArr = store?.values[C.KEY_DINEIN_PAYMENT_TYPES];
    if (val) {
      paymentArr?.push(v);
    } else {
      const index = paymentArr.indexOf(v);
      if (index > -1) paymentArr.splice(index, 1);
    }
    setStore((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [C.KEY_DINEIN_PAYMENT_TYPES]: paymentArr,
      },
      errors: {
        ...prevState.errors,
      },
    }));
  };

  const handleTwentyFourHours = (key, val) => {
    setStore((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val,
      },
      errors: {
        ...prevState.errors,
      },
    }));

    if (val) {
      setStore((prevState) => ({
        ...prevState,
        values: {
          ...prevState.values,
          [key]: val,
          workingHoursForDinein: {
            saturdayStartTime: C.START_TIME_24_HOURS,
            saturdayEndTime: C.END_TIME_24_HOURS,
            saturdayStartTimeSlot2: null,
            saturdayEndTimeSlot2: null,

            sundayStartTime: C.START_TIME_24_HOURS,
            sundayEndTime: C.END_TIME_24_HOURS,
            sundayStartTimeSlot2: null,
            sundayEndTimeSlot2: null,

            mondayStartTime: C.START_TIME_24_HOURS,
            mondayEndTime: C.END_TIME_24_HOURS,
            mondayStartTimeSlot2: null,
            mondayEndTimeSlot2: null,

            tuesdayStartTime: C.START_TIME_24_HOURS,
            tuesdayEndTime: C.END_TIME_24_HOURS,
            tuesdayStartTimeSlot2: null,
            tuesdayEndTimeSlot2: null,

            wednesdayStartTime: C.START_TIME_24_HOURS,
            wednesdayEndTime: C.END_TIME_24_HOURS,
            wednesdayStartTimeSlot2: null,
            wednesdayEndTimeSlot2: null,

            thursdayStartTime: C.START_TIME_24_HOURS,
            thursdayEndTime: C.END_TIME_24_HOURS,
            thursdayStartTimeSlot2: null,
            thursdayEndTimeSlot2: null,

            fridayStartTime: C.START_TIME_24_HOURS,
            fridayEndTime: C.END_TIME_24_HOURS,
            fridayStartTimeSlot2: null,
            fridayEndTimeSlot2: null,

            sunday: true,
            saturday: true,
            friday: true,
            thursday: true,
            wednesday: true,
            tuesday: true,
            monday: true,
          },
        },
        errors: {
          ...prevState.errors,
        },
      }));
    }
  };
  return (
    <div className="w-full mb-3">
          <AppCollapse
              defaultOpen={defaultOpen}
              title={t("Dine In Options")}
              subtitle={t("Set dine-in availability and table preferences.")}
            >
              <div className="space-y-6">
    
                {/* Delivery Toggle */}
                <div className="flex items-center">
                  <AppSwitch label={t("Dine In")} labelLeft={false} checked={isON(serviceTypes[2]?._id)}  onChange={(val)=>toggleDelivery( store.values[C.ISDINEINENABLED], serviceTypes[2]?._id)}/>
                </div>
                {
                  isON(serviceTypes[2]?._id) && 
                  <>
                    {/* Payment Methods */}
                    <div className="space-y-3">
                      <AppHeading2>Supported Payment Methods?</AppHeading2>
                      <ul className="px-5 text-blue-600 text-16px space-y-2 list-disc">
                        {infoMessages.map((item,index)=>(
                        <li key={index} className="text-sm leading-relaxed">
                        <span>{t(item.message)} </span>
                        {item.links.map((link, i) => (
                          <React.Fragment key={i}>
                            <a
                              href={link.href}
                              target={link.target}
                              rel="noopener noreferrer"
                              className="text-red-600 underline mx-1"
                            >
                              {t(link.text)}
                            </a>
                            {i < item.links.length - 1 && <span>{t(item.separator)}</span>}
                          </React.Fragment>
                        ))}
                        {item.links.length === 1 && <span>{t(item.separator)}</span>}.
                      </li>
                      
                        ))}
                      </ul>
                    </div>
                    {/* Preparation Time */}
                    <AppInput
                      label="Average Preparation Time"
                      placeholder="Example 30 Mins"
                      value={store?.values?.averagePrepTimeForDinein}
                      onInput={(e)=>handleStoreInfo("averagePrepTimeForDinein", e.target.value)}
                    />
                    {/* Store Hours */}
                    <div className="space-y-3">
                      <AppHeading2>
                        {t("Set the hours your store is open for delivery")}
                      </AppHeading2>

                      <div className="flex items-center">
                        <AppSwitch
                          label="Open 24 Hours to Accept Orders"
                          labelLeft={false}
                          checked={store?.values?.isStoreOpen24HoursForDinein}
                          onChange={(e)=>handleTwentyFourHours('isStoreOpen24HoursForDinein',e)}
                        />
                      </div>
                      {
                        !store?.values?.isStoreOpen24HoursForDinein && 
                        <div className="w-full">
                          <StoreHoursSection store={store} setStore={setStore} hoursField="workingHoursForDinein" />
                        </div>
                      }
                    </div>
                  </>
                }
              </div>
            </AppCollapse>
          
        </div>
    // <>
    //   <ServiceType />

    //   {isON(serviceTypes[2]?._id) && (
    //     <>
    //       <PaymentTypes
    //         serviceType="DINE IN"
    //         paymentType={C.KEY_DINEIN_PAYMENT_TYPES}
    //         values={store.values}
    //         errors={store.errors.delivery}
    //         handleValues={handlePaymentTypes}
    //         addStore={addStore}
    //         setStore={setStore}
    //       />
    //       <div className="pb-2">
    //         <TextInput
    //           label={t("Average Preparation Time")}
    //           value={getValue("averagePrepTimeForDinein")}
    //           placeHolder="Example 24 Hours"
    //           keyVal={"averagePrepTimeForDinein"}
    //           handleValues={handleStoreInfo}
    //           mandatory={true}
    //           error={t(store.errors.averagePrepTimeForDinein)}
    //         />
    //       </div>
    //       <WorkingHours
    //         values={store.values}
    //         store={store}
    //         handleTwentyFourHours={handleTwentyFourHours}
    //         type={type}
    //         addStore={addStore}
    //         setStore={setStore}
    //       />
    //     </>
    //   )}
    // </>
  );
}

export default Delivery;
